define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var VisitorListTableViewController = require('web-agent-viewControllers/VisitorListTableViewController');
    var EngagementsHistoryTableViewController = require('web-agent-viewControllers/EngagementsHistoryTableViewController');
    var MyConnectionsListTableViewController = require('web-agent-viewControllers/MyConnectionsListTableViewController');
    var AppConnectionsListTableViewController = require('web-agent-viewControllers/AppConnectionsListTableViewController');
    var ConnectionsLogTableViewController = require('web-agent-viewControllers/ConnectionsLogTableViewController');
    var AgentListTableViewController = require('web-agent-viewControllers/AgentListTableViewController');
    var MessagingAgentListTableViewController = require('web-agent-viewControllers/MessagingAgentListTableViewController');

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    // var MainViewController = require('web-agent-viewControllers/MainViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    /*
     Tab Manager ViewController create and manage the tabs that contain the webAgent tables.
     */
    var TabsManagerViewController;
    TabsManagerViewController = ViewController.extend({
        ControllerName: 'TabsManagerViewController',
        applicationType: 'TabsManagerViewController',
        tabsArray: [],
        buttonArray: [],
        animationDuration: 200,
        selectedTabId: 0,
        LPClassesMap: {
            visitorListTableClass: "visitor_list_table",
            engagementsHistoryTableClass: "engagements_history_table",
            agentListTableClass: "agent_list_table",
            myConnectionsTableClass: "my_connections_list_table",
            appConnectionsTableClass: "app_connections_list_table",
            connectionsLogTableClass: "connections_log_table",
            messagingAgentListTableClass: "messaging_agent_list_table"
        },

        LPViewMap: {
            tabsManagerButtonsContainer: ".lpview_tabs_manager_buttons_container",
            tabsSlider: ".lpview_tabs_manager_slider",
            tabButton: ".lpview_tabButton",
            underLine: ".lpview_underLine",
            tabContainer: ".tabButton"
        },

        initialize: function (constructorData) {
            this.tabsSlider = this.getFirstElement(this.LPViewMap.tabsSlider);
            this.underLine = this.getFirstElement(this.LPViewMap.underLine);
            this.tabsBodyWidth = window.MainViewControllerBody.offsetWidth;
        },

        events: function () {
            this.bindModel({modelPath: "agent.status", callback: this.handleStatusChanged});
            this.bindViewEvent({selector: window, DOMEvent: "resize", callback: this.resizeWindow});
        },

        render: function () {
        }
    });

    TabsManagerViewController.prototype.handleStatusChanged = function (data) {
        if (data && typeof data.newValue !== 'undefined') {
            if (data.newValue !== "loggedOff") {
                this.initTabs();
            }
        }
    };

    TabsManagerViewController.prototype.initTabs = function () {
        if (this.tabsInitialized) {
            return;
        }
        this.tabsInitialized = true;


        //Init the messaging tables
        if (lpTag.WebAgent.logicController.hasMessagingFeature()) {
            if (privilegesController.hasViewAllChatsPrivilege() || privilegesController.hasAgentManagerModulePrivilege()) {
                this.createAppConnectionsList();
            } else if (lpTag.WebAgent.logicController.hasAgentViewPrivilege()) {
                this.createMyConnectionsList();
            }
        }

        // Init the connections logs (allConnections) table.
        if (lpTag.WebAgent.logicController.isMessagingHistoryEnabled()) {
            this.createConnectionsLog();
        }

        //Init the visitors table
        this.createVisitorsList();

        //Init the history table
        if (privilegesController.hasViewHistoryPrivilege()) {
            this.createEngagementsHistory();
        }

        var isMessagingAgentListEnabled = lpTag.WebAgent.logicController.hasMessagingFeature() && lpTag.WebAgent.logicController.hasMessagingAgentListEnabled();

        //Init the agents table
        if (privilegesController.hasViewAgentListPrivilege()) {
            this.createAgentList(isMessagingAgentListEnabled);
        }

        if (isMessagingAgentListEnabled) {
            this.createMessagingAgentList();
        }

        // set the selected tab
        var selectedTabId = this.modelController.getSessionData({name: this.applicationType, key: "selectedTabId"}) || 0;
        this.setTab(selectedTabId, false);
        this.initTabUnderline();
        this.bindTabsManager();
        this.bindViewEvent({selector: ".tab", DOMEvent: "keydown", callback: this.onKeyDown});

        this.calculateTabsWidth();
    };

    TabsManagerViewController.prototype.onKeyDown = function (e) {
        if (e.keyCode === 9) {
            e.preventDefault();
        }
    };


    TabsManagerViewController.prototype.initTabUnderline = function () {
        // get the padding of the buttons for the underline
        var firstButton = this.buttonArray[0];
        var paddingLeft = this.getComputedStyle(firstButton, 'padding-left', 10);
        var paddingRight = this.getComputedStyle(firstButton, 'padding-right', 10);
        this.menuButtonsPadding = paddingLeft + paddingRight;
        // Add the underline on the tabs menu and set it to the right tab button on the menu
        this.setUnderLinePosition(this.selectedTabId, false);
        if (this.tabsArray.length > 1) {
            this.lpShow(this.underLine);
        }
    };

    TabsManagerViewController.prototype.bindTabsManager = function () {
        this.bindViewEvent({selector: this.LPViewMap.tabButton, DOMEvent: "click", callback: this.tabButtonClicked});
        this.viewEventsHandler.bindEvent({
            appName: TabsManagerViewController.applicationType,
            UIEvent: this.eventType.VISITOR_FOCUSED,
            callback: this.onVisitorFocus,
            trigger: false
        });
        this.viewEventsHandler.bindEvent({
            appName: TabsManagerViewController.applicationType,
            UIEvent: this.eventType.VISITOR_BLURRED,
            callback: this.onVisitorBlur
        });
    };

    TabsManagerViewController.prototype.onVisitorFocus = function () {
        setTimeout(this.focusTables.bind(this), 0);
    };

    TabsManagerViewController.prototype.onVisitorBlur = function () {
        setTimeout(this.blurTables.bind(this), 0);
    };

// On resize window change the width of the tabs manually
    TabsManagerViewController.prototype.resizeWindow = function () {
        this.tabsBodyWidth = window.MainViewControllerBody.offsetWidth;
        for (var i = 0; i < this.tabsArray.length; i++) {
            this.tabsArray[i].element.style.width = this.tabsBodyWidth + "px";
        }

        // move to the right position
        this.tabsSlider.style.marginLeft = "-" + (this.tabsBodyWidth * (this.selectedTabId)) + "px";
        this.tabsSlider.style.width = (this.tabsBodyWidth * (this.tabsArray.length)) + "px";
        this.calculateTabsWidth();
    };
    /*
     Create new tub and button
     @param title - The text that need to be on the menu button
     @param focusedName - The string to send on focuses notification
     @returns the new tab element
     */
    TabsManagerViewController.prototype.createNewTab = function (title, focusedName, viewController) {
        var newTab = this.createView({
            target: this.LPViewMap.tabsSlider,
            className: "tab",
            elementType: "div"
        });
        // Set the tab width the same as MainViewController
        newTab.style.width = this.tabsBodyWidth + "px";
        // Add the tab to the tabs array
        this.tabsArray.push({element: newTab, focusedName: focusedName, viewController: viewController});
        // Set the width of the tabsSlider to be 100% * number of tabs
        var tabCount = this.tabsArray.length;
        this.tabsSlider.style.width = (this.tabsBodyWidth * (tabCount)) + "px";

        this.createNewButton(title, viewController.tableDescription, focusedName);

        return newTab;
    };
    /*
     Create a new button for the new tab
     @param id - The id of the tab
     @param title - The text that need to be on the menu button
     */

    TabsManagerViewController.prototype.createNewButton = function (title, description, name) {
        var newButton = this.createView({
            target: this.LPViewMap.tabsManagerButtonsContainer,
            elementType: "li",
            className: "tabButton" + " " + name.replace("ViewController", ""),
            textInjection: {
                titleText: this.translate(title),
                tableDescription: this.translate(description)
            },
            templateFile: 'LP_tabs_manager_button.html'
        });
        this.buttonArray.push(newButton);
        // Set the class name with the tab id. if this is the first tab add class .first and .active
        // TODO: handle case that view start with different active tab
        if (this.buttonArray.length == 1) {
            this.addClass(newButton, ["first", "active"]);
        }
    };
    /*
     Create the visitorsList view controller
     */
    TabsManagerViewController.prototype.createVisitorsList = function () {
        var visitorListTable = new VisitorListTableViewController({
            modelController: lpTag.WebAgent.visitorFeedController,
            tableClass: this.LPClassesMap.visitorListTableClass
        });
        var tab = this.createNewTab(visitorListTable.LPPrefixMap.visitorList + "_table_title", visitorListTable.applicationType, visitorListTable);
        this.addViewController({viewController: visitorListTable, target: tab});
    };
    /*
     Create the myConnectionsList view controller
     */
    TabsManagerViewController.prototype.createMyConnectionsList = function () {
        var myConnectionsListTable = new MyConnectionsListTableViewController({
            tableClass: this.LPClassesMap.myConnectionsTableClass,
            modelController: MyConnectionsListTableViewController.prototype.getModelControllerInstance()
        });
        var tab = this.createNewTab(myConnectionsListTable.LPPrefixMap.myConnectionsList + "_table_title", myConnectionsListTable.applicationType, myConnectionsListTable);
        this.addViewController({viewController: myConnectionsListTable, target: tab});
    };

    TabsManagerViewController.prototype.createAppConnectionsList = function () {
        var appConnectionsListTable = new AppConnectionsListTableViewController({
            tableClass: this.LPClassesMap.appConnectionsTableClass,
            modelController: AppConnectionsListTableViewController.prototype.getModelControllerInstance()
        });
        var tab = this.createNewTab(appConnectionsListTable.LPPrefixMap.appConnectionsList + "_table_title", appConnectionsListTable.applicationType, appConnectionsListTable);
        this.addViewController({viewController: appConnectionsListTable, target: tab});
    };

    TabsManagerViewController.prototype.createConnectionsLog = function () {
        var connectionsLogTable = new ConnectionsLogTableViewController({
            tableClass: this.LPClassesMap.connectionsLogTableClass,
            modelController: ConnectionsLogTableViewController.prototype.getModelControllerInstance()
        });
        var tab = this.createNewTab(connectionsLogTable.LPPrefixMap.connectionsLog + "_table_title", connectionsLogTable.applicationType, connectionsLogTable);
        this.addViewController({viewController: connectionsLogTable, target: tab});
    };


    TabsManagerViewController.prototype.createEngagementsHistory = function () {
        var engagementHistoryTable = new EngagementsHistoryTableViewController({
            modelController: lpTag.WebAgent.engagementsHistoryTableController,
            tableClass: this.LPClassesMap.engagementsHistoryTableClass
        });
        // TODO: inject the title from lang file
        var tab = this.createNewTab(engagementHistoryTable.LPPrefixMap.engagementsHistory + "_table_title", engagementHistoryTable.applicationType, engagementHistoryTable);
        this.addViewController({viewController: engagementHistoryTable, target: tab});
    };

    TabsManagerViewController.prototype.createAgentList = function (messagingAgentListEnabled) {
        var agentListTable = new AgentListTableViewController({
            modelController: lpTag.WebAgent.agentListController,
            tableClass: this.LPClassesMap.agentListTableClass
        });
        var titleSuffex = messagingAgentListEnabled ? '_table_title_all' : '_table_title';
        var tab = this.createNewTab(agentListTable.LPPrefixMap.agentList + titleSuffex, agentListTable.applicationType, agentListTable);
        this.addViewController({viewController: agentListTable, target: tab});
    };

    TabsManagerViewController.prototype.createMessagingAgentList = function () {
        var messagingAgentListTable = new MessagingAgentListTableViewController({
            tableClass: this.LPClassesMap.messagingAgentListTableClass,
            modelController: MessagingAgentListTableViewController.prototype.getModelControllerInstance()
        });
        var tab = this.createNewTab(messagingAgentListTable.LPPrefixMap.messagingAgentList + "_table_title", messagingAgentListTable.applicationType, messagingAgentListTable);
        this.addViewController({viewController: messagingAgentListTable, target: tab});
    };

    /*
     Event callback on menu button clicked
     */
    TabsManagerViewController.prototype.tabButtonClicked = function (data) {
        var buttonContainer = this.getParentElementBySingleSelector(data.currentTarget, '.tabButton');
        if (buttonContainer) {
            var buttonID = this.buttonArray.indexOf(buttonContainer);
            this.setTab(buttonID);
        }
    };

    /**********************
     Tabs animation
     ***********************/
    /*
     Move the tabsSlider to show the selected tab
     @param tabID - the tab id that need to be shown
     */
    TabsManagerViewController.prototype.setTab = function (tabID, animate) {
        animate = typeof animate !== "undefined" ? animate : true;

        // bug fix: removing animation to IE
        animate = !lpUtils._isIE() ? animate : false;

        var animateTo = tabID;
        var hStart, hEnd;

        // Check if need to jump more then one tab
        // If true hide all the tabs between
        if (this.selectedTabId - tabID > 1) { // going back
            this.hideTabs(tabID + 1, this.selectedTabId - 1);
            hStart = tabID + 1;
            hEnd = this.selectedTabId - 1;
            // Set the new location of the tabSlider
            this.tabsSlider.style.marginLeft = "-" + (this.tabsBodyWidth * (tabID + 1)) + "px";
            animateTo = tabID;
        } else if (tabID - this.selectedTabId > 1) { // going forward
            this.hideTabs(this.selectedTabId + 1, tabID - 1);
            hStart = this.selectedTabId + 1;
            hEnd = tabID - 1;
            // Set the new location of the tabSlider
            this.tabsSlider.style.marginLeft = "-" + (this.tabsBodyWidth * (this.selectedTabId)) + "px";
            animateTo = this.selectedTabId + 1;
        }

        // Send focus notification
        this.notifyFocusedChange(tabID, tabID === this.selectedTabId);

        var that = this;
        if (animate) {
            // Run animation
            this.setUnderLinePosition(tabID, true);
            this.animate(this.tabsSlider, {
                duration: this.animationDuration,
                marginLeft: "-" + (this.tabsBodyWidth * (animateTo)) + "px"
            }, function () {
                that.endAnimation(tabID, hStart, hEnd);
            });
        } else {
            this.setUnderLinePosition(tabID, false);
            this.endAnimation(tabID, hStart, hEnd);
        }

        // Save to current tab to session storage
        this.modelController.saveSessionData({name: this.applicationType, key: "selectedTabId", value: tabID});
    };
// Callback for end animation
    TabsManagerViewController.prototype.endAnimation = function (tabID, hStart, hEnd) {
        this.showTabs(hStart, hEnd);

        this.tabsSlider.style.marginLeft = "-" + (this.tabsBodyWidth * (tabID)) + "px";

        // Remove the .active class name from the old menu button and adding it to the new one.
        this.removeClass(this.buttonArray[this.selectedTabId], "active");
        this.selectedTabId = tabID;
        this.addClass(this.buttonArray[this.selectedTabId], "active");

    };

    TabsManagerViewController.prototype.hideTabs = function (start, end) {
        for (var i = start; i <= end; i++) {
            var selectedButton = this.tabsArray[i].element;
            this.lpHide(selectedButton);
        }
    };
    TabsManagerViewController.prototype.showTabs = function (start, end) {
        for (var i = start; i <= end; i++) {
            var selectedButton = this.tabsArray[i].element;
            this.lpShow(selectedButton);
        }
    };

// Animate the tabs menu underline
    TabsManagerViewController.prototype.setUnderLinePosition = function (id, animation) {
        var selectedButton = this.buttonArray[id];
        var newLeft = selectedButton.offsetLeft;
        var newWidth = selectedButton.offsetWidth - this.menuButtonsPadding;
        // check if need to run animation or just set the new style
        if (animation) {
            this.animate(this.underLine, {duration: this.animationDuration, left: newLeft + "px"});
            this.animate(this.underLine, {duration: this.animationDuration, width: newWidth + "px"});
        } else {
            this.underLine.style.left = newLeft + "px";
            this.underLine.style.width = newWidth + "px";
        }
    };
    /*
     Send Focused Notification with the selected tab
     @param id - The id of the focused tab
     */
    TabsManagerViewController.prototype.notifyFocusedChange = function (id, showLoading) {
        this.tabsArray[this.selectedTabId].viewController.blurTable();
        this.tabsArray[id].viewController.focusTable(showLoading);
        var focusedName = this.tabsArray[id].focusedName;
        agentLEManager.setLEValue('webAgent.focusedComponent', 'VisitorTables:' + focusedName);
        LE.context.set("LEWebAgent.page", focusedName);
        LE.vent.trigger(LE.mediaCodes.webAgent.vent.visitorTablesVisible);
    };

    /*
     When losing the focus, hide the tabs (and the tables)
     */
    TabsManagerViewController.prototype.blurTables = function () {
        this.tabsArray[this.selectedTabId].viewController.blurTable();
        this.lpHide();
    };
    /*
     When focus back, show the tabs (and the right table)
     */
    TabsManagerViewController.prototype.focusTables = function () {
        this.lpShow();
        this.setTab(this.selectedTabId, false);
    };

    /*
     Calculate the optimal tab width according to tab container
     */
    TabsManagerViewController.prototype.calculateTabsWidth = function () {
        var tabContainer = this.getFirstElement(this.LPViewMap.tabsManagerButtonsContainer),
            containerWidth = this.getComputedWidth(tabContainer).totalWidth,
            visibleTabs = this.getElements(this.LPViewMap.tabContainer, tabContainer),
            normalTabWidth = containerWidth / visibleTabs.length,
            sumGoodTabsWidth = 0,
            tabsForReduce = [],
            tabWidth,
            aveRemainWidth,
            fixedMaxWidth,
            i;

        if (containerWidth) {

            // When calculating the width, remove the max width so the calculation will be ok,
            this.clearMaxWidth(visibleTabs);

            // Find the big tabs, and sum the small tabs.
            for (i = 0; i < visibleTabs.length; i++) {

                // Getting actual tab width
                tabWidth = this.getComputedWidth(visibleTabs[i]).totalWidth;

                // Checking if it more than the avg so we can add more space later if we have
                if (tabWidth > normalTabWidth) {
                    tabsForReduce.push(visibleTabs[i]);
                } else {

                    // Calculating the sum of widths of tabs which are below the avg and we can take space from them
                    sumGoodTabsWidth += tabWidth;
                }
            }


            // Checking if we have tabs that needs to add space and that we have space left to add
            if (tabsForReduce.length > 0 && (containerWidth - sumGoodTabsWidth) > 0 ) {

                // Calculating the maximum avg width we can give for each tab
                aveRemainWidth = (containerWidth - sumGoodTabsWidth) / tabsForReduce.length;

                for (i = 0; i < tabsForReduce.length; i++) {
                    tabWidth = this.getComputedWidth(visibleTabs[i]);

                    // parseInt for removing the digit after the dot. (1.999999)
                    // maxWidth include only the actual width, and exclude the margin, border & padding.
                    // Therefore, we need to remove from the max width the space of margin, border & padding.
                    fixedMaxWidth = Math.floor(aveRemainWidth - tabWidth.margin - tabWidth.border - tabWidth.padding);
                    tabsForReduce[i].style.maxWidth = fixedMaxWidth + "px";

                }
            }


            this.setUnderLinePosition(this.selectedTabId, false);
        }

    };

    TabsManagerViewController.prototype.clearMaxWidth = function (views) {
        for (var i = 0; i < views.length; i++) {
            views[i].style.maxWidth = "";
        }
    };

    TabsManagerViewController.prototype.getComputedWidth = function (element) {
        var style = element.currentStyle || window.getComputedStyle(element),
            width = element.offsetWidth,
            margin = parseFloat(style.marginLeft, 10) + parseFloat(style.marginRight, 10),
            padding = parseFloat(style.paddingLeft, 10) + parseFloat(style.paddingRight, 10),
            border = parseFloat(style.borderLeftWidth, 10) + parseFloat(style.borderRightWidth, 10);

        return {
            width: width,
            margin: margin,
            padding: padding,
            border: border,
            totalWidth: width + margin + border
        };
    };

    return TabsManagerViewController;

});
